import FactsheetIcon from '@/assets/icons/Factsheet';

import FactsheetDialogButtonBase from './FactsheetDialogButtonBase';

const FactsheetDialogButton = ({
  code,
  fontSize = 16,
  mode,
  showTooltip = false
}: {
  code: string;
  fontSize?: number;
  mode?: 'modal' | 'newTab';
  showTooltip?: boolean;
}) => {
  return (
    <FactsheetDialogButtonBase
      ariaLabel={`Open factsheet for ${code}`}
      code={code}
      mode={mode}
      tooltip={showTooltip ? 'Click to see index information' : undefined}
    >
      <FactsheetIcon
        className='size-[1em]'
        style={{ fontSize }}
      />
    </FactsheetDialogButtonBase>
  );
};
export default FactsheetDialogButton;
